<template>
    <v-card-actions
        class="plot-footer"
        :class="{
            'absolute-layout': absoluteLayoutType.includes(type),
            'justify-center': type === 'plot-grid'
        }"
    >
        <v-btn
            id="gtm-plotcard-cta-discover"
            outlined
            small
            class="habiteo-btn promoter-customization text-capitalize"
            :class="{
                'xs': $vuetify.breakpoint.xs,
                'mr-4': $vuetify.breakpoint.mdAndUp,
            }"
            @click.prevent="updateWidget(data)"
        >
            {{ $t('widgets.plot.discover') }}
        </v-btn>
    </v-card-actions>
</template>

<script>
    export default {
        name: 'PlotFooter',
        props: {
            data: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                absoluteLayoutType: [
                    'plot'
                ]
            }
        },
        methods: {
            updateWidget(plot) {
                this.$emit('update-widget', plot);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .plot-footer {
        &.absolute-layout {
            position: absolute;
            bottom: 0px;
            right: 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/layout/PlotFooter.vue